import { SET_USER, UPDATE_PERMISSIONS } from '../../actions/auth';

const initialState = {
    user: null,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            return { user: action.payload };
        case UPDATE_PERMISSIONS:
            return { user: { ...state.user, acces: action.payload } };
        default:
            return state;
    }
};

export default auth;
